export { default } from './HeroIntegrationVisual'
